export const AuthFooter = () => {
  return (
    <div className="h-10  border-t">
      <div
        className="font-heading font-medium font-m text-sm text-center
       lg:font-medium lg:text-base mt-3"
      >
        © 2026 Zamchainadvanceinvestment All right reserved.
      </div>
    </div>
  );
};
